import React, { useEffect, useState } from 'react'
import '../../assets/css/Profile.css'
import { toast, ToastContainer } from 'react-toastify';
import axios from 'axios';

function Profile() {
    const [user, setUser] = useState({ name: '', email: '' });
    const [loading, setLoading] = useState(false);

    const API_URL = "https://devapi.bykit.in/api/admin/update-profile??type=live";

    useEffect(() => {
        const storedUser = localStorage.getItem('LoginData');
        if (storedUser) {
            setUser(JSON.parse(storedUser));
        }
    }, []);

    const handleChange = (e) => {
        setUser({ ...user, [e.target.name]: e.target.value });
    };

    const handleUpdate = async (e) => {
        e.preventDefault();
        setLoading(true);
    
        const storedLoginData = JSON.parse(localStorage.getItem("LoginData"));
        const token = storedLoginData?.token;

        const payload ={
            name: user.name,
            email: user.email,
        }
        try {
            const response = await axios.post( API_URL, payload, {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            });

            console.log('profile update', response)
    
            if (response.data.status === "RC200") {
                toast.success("Profile updated successfully!", { position: "top-right" });
    
                // Update localStorage with new data
                localStorage.setItem("LoginData", JSON.stringify({ ...storedLoginData, name: user.name, email: user.email }));
            } else {
                toast.error("Failed to update profile. Try again.", { position: "top-right" });
            }
        } catch (error) {
            console.error("Error updating profile:", error);
            toast.error("An error occurred while updating.", { position: "top-right" });
        } finally {
            setLoading(false);
        }
    };
    

    return (
        <div className='p-3'>
            <ToastContainer></ToastContainer>
            <div className="d-flex align-items-center gap-3">
                <svg className="custom-icon" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" width="20px" height="20px" viewBox="0 0 24 24">
                    <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m3 12l2-2m0 0l7-7l7 7M5 10v10a1 1 0 0 0 1 1h3m10-11l2 2m-2-2v10a1 1 0 0 1-1 1h-3m-6 0a1 1 0 0 0 1-1v-4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v4a1 1 0 0 0 1 1m-6 0h6"></path>
                </svg>

                <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" width="18px" height="18px" viewBox="0 0 24 24">
                    <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m8.25 4.5l7.5 7.5l-7.5 7.5"></path>
                </svg>

                <p className="m-0">Profile Details</p>
            </div>

            <div className='row'>
                <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                    <div className='managebrand_box mt-3'>
                        <h4 className='dashboard_head py-4 ps-4 m-0'>Profile Details</h4>
                        <hr className='p-0 m-0'></hr>
                        <div className='p-4'>
                            <form onSubmit={handleUpdate}>
                                <div>
                                    <label className="form-label signin_label">Name</label>
                                    <input type='text' placeholder='name' name='name' className='form-control'  value={user.name} onChange={handleChange} ></input>
                                </div>
                                <div className='mt-3'>
                                    <label className="form-label signin_label">Email Address</label>
                                    <input type='text' placeholder='Email Address' email='email' className='form-control'  value={user.email}  onChange={handleChange} ></input>
                                </div>
                                <div className="d-flex justify-content-end mt-3">
                                    <button type="submit" className="btn submit_btn d-flex align-items-center gap-2">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            aria-hidden="true"
                                            role="img"
                                            className="iconify iconify--ic"
                                            width="1em"
                                            height="1em"
                                            viewBox="0 0 24 24"
                                        >
                                            <path
                                                fill="currentColor"
                                                d="M17.59 3.59c-.38-.38-.89-.59-1.42-.59H5a2 2 0 0 0-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7.83c0-.53-.21-1.04-.59-1.41zM12 19c-1.66 0-3-1.34-3-3s1.34-3 3 3s3 1.34 3 3s-1.34 3-3 3m1-10H7c-1.1 0-2-.9-2-2s.9-2 2-2h6c1.1 0 2 .9 2 2s-.9 2-2 2"
                                            ></path>
                                        </svg>
                                        <span>  {loading ? "Updating..." : "Update Profile"}</span>
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default Profile